import React, { Fragment } from 'react'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom' // Next.js kullanıyorsan: import { useRouter } from 'next/navigation'

// Components
import ThemeMenuOne from '../../../components/header/ThemeMenuOne'
import PageTitle from '../../../components/page-title/PageTitle'
import NewsletterTwo from '../../../components/call-to-action/NewsletterTwo'
import FooterTwo from '../../../components/footer/FooterTwo'

const CruxestackSign = () => {
    const navigate = useNavigate(); // Next.js ise: const router = useRouter();

    // App Navigation
    const handleGetStarted = () => {
    window.open('https://sign.cruxestack.com/', '_blank');
};

    return (
        <Fragment>
            <div className="main-page-wrapper">

                {/* Helmet */}
                <Helmet>
                    <title>Cruxestack Sign</title>
                </Helmet>

                {/* Header */}
                <ThemeMenuOne />

                {/* Page Title */}
                <PageTitle title="Cruxestack Sign" />

                {/* HERO SECTION */}
                <section className="cruxestack-sign-hero pt-120 pb-80 pt-lg-60 pb-lg-40">
                    <div className="container">
                        
                        {/* Section Header */}
                        <div className="row justify-content-center">
                            <div className="col-xl-8 col-lg-10 text-center">
                                <div className="section-title mb-35">
                                    <span className="text-uppercase fw-bold  mb-2 d-block" style={{ letterSpacing: '1.5px', fontSize: '13px' }}>
                                        Seal the Deal, Openly
                                    </span>
                                    <h2 className="sect-title mb-20" data-aos="fade-up">
                                        Welcome to Cruxestack Sign
                                    </h2>
                                    <p className="fs-5 text-muted mb-4" data-aos="fade-up" data-aos-delay="100">
                                        Your ultimate PDF E-Signature solution. Transform the way you sign, store, and secure your documents — all in one place, completely free.
                                    </p>

                                    {/* Main CTA Button */}
                                    <div className="d-flex justify-content-center mb-4" data-aos="fade-up" data-aos-delay="150">
                                        <button 
                                            onClick={handleGetStarted}
                                            className="btn btn-primary btn-lg rounded-pill px-5 py-3 fw-bold shadow-sm"
                                        >
                                            Get Started Now
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Main App Preview Banner */}
                        <div className="row justify-content-center mb-5" data-aos="fade-up" data-aos-delay="200">
                            <div className="col-xl-10">
                                <div className="rounded-4 overflow-hidden shadow-sm bg-light text-center p-2 border">
                                    <img 
                                        src="https://sign.cruxestack.com/assets/logo-v8fUodGc.png" 
                                        alt="Cruxestack Sign App Preview" 
                                        className="img-fluid rounded-3 w-100" 
                                        style={{ maxHeight: '125px', objectFit: 'contain' }}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Unlimited Free Plan Banner */}
                        <div className="row justify-content-center" data-aos="fade-up">
                            <div className="col-xl-8">
                                <div className="p-4 rounded-4 text-center border border-primary-subtle bg-light-subtle">
                                    <h4 className="fw-bold  mb-2">Discover Our FREE Plan with Unlimited E-Signatures!</h4>
                                    <p className="mb-0 text-secondary">
                                        Experience the freedom of limitless digital signing without ever reaching for your wallet.
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>

                {/* FEATURES SECTION */}
                <section className="bg-light py-5">
                    <div className="container py-4">
                        <div className="row justify-content-center text-center mb-5">
                            <div className="col-lg-6">
                                <h3 className="fw-bold">Key Capabilities</h3>
                                <p className="text-muted">Designed to streamline your signing workflow at zero cost.</p>
                            </div>
                        </div>

                        <div className="row g-4 justify-content-center">
                            {/* Feature 1 */}
                            <div className="col-lg-4 col-md-6" data-aos="fade-up">
                                <div className="p-4 bg-white rounded-4 border h-100 text-center">
                                    <h5 className="fw-bold mb-2 text-dark">Invite & Collaborate for Free</h5>
                                    <p className="text-muted small mb-0">
                                        Bring multiple people into the signing process at no extra cost. Close deals, not your wallet.
                                    </p>
                                </div>
                            </div>

                            {/* Feature 2 */}
                            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
                                <div className="p-4 bg-white rounded-4 border h-100 text-center">
                                    <h5 className="fw-bold mb-2 text-dark">Free Completion Certification</h5>
                                    <p className="text-muted small mb-0">
                                        Every signed document comes with a detailed completion certificate, featuring full access logs at zero cost.
                                    </p>
                                </div>
                            </div>

                            {/* Feature 3 */}
                            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
                                <div className="p-4 bg-white rounded-4 border h-100 text-center">
                                    <h5 className="fw-bold mb-2 text-dark">Cruxestack Drive Vault</h5>
                                    <p className="text-muted small mb-0">
                                        Your documents deserve a safe home. Store and organize them for free in our secure Cruxestack Drive vault.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* ABOUT / WHY CHOOSE SECTION */}
                <section className="py-5 my-4">
                    <div className="container py-4">
                        <div className="row justify-content-center">
                            <div className="col-lg-10" data-aos="fade-up">
                                <div className="p-5 bg-white rounded-4 border shadow-sm">
                                    <h3 className="fw-bold mb-3 text-center">What is Cruxestack Sign?</h3>
                                    <p className="text-muted mb-4 text-center">
                                        At Cruxestack Sign, we’re redefining the landscape of digital signatures. Our mission is to make digital document signing not just a formality, but an integral part of your organization's digital transformation journey. Cruxestack Sign is your gateway to a world where efficiency, security, and simplicity reign supreme.
                                    </p>

                                    <hr className="my-6 text-muted opacity-25" />

                                    <h4 className="fw-bold mb-5  text-center">Why Choose Cruxestack Sign?</h4>
                                    <div className="row g-4 ">
                                        <div className="col-md-6">
                                            <h6 className="fw-bold  mb-4">Innovative Technology</h6>
                                            <p className="text-muted small mb-10">Harness the latest advancements in e-signature technology for seamless workflows.</p>
                                        </div>
                                        <div className="col-md-6">
                                            <h6 className="fw-bold mb-4">Data-Driven Security</h6>
                                            <p className="text-muted small mb-10">Encryption and compliance come first. Self-host option available for full data control.</p>
                                        </div>
                                        <div className="col-md-6">
                                            <h6 className="fw-bold mb-4">User-Centric Design</h6>
                                            <p className="text-muted small mb-10">Designed for ultimate ease of use — get started instantly without hours of training.</p>
                                        </div>
                                        <div className="col-md-6">
                                            <h6 className="fw-bold mb-4">Scalable Solutions</h6>
                                            <p className="text-muted small mb-10">Scales effortlessly from free individual accounts to enterprise SSO and custom branding.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Newsletter */}
                <NewsletterTwo />

                {/* Footer */}
                <FooterTwo />

            </div>
        </Fragment>
    )
}

export default CruxestackSign